import { render, staticRenderFns } from "./SuccessfulProcess.vue?vue&type=template&id=5b9d3422&"
import script from "./SuccessfulProcess.vue?vue&type=script&lang=js&"
export * from "./SuccessfulProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports